// Layers
import PageLayer from "@Layouts/views/PageLayer";

// Components
import SalesOperationsLayer from "@DataPages/components/SalesOperations/SalesOperationsLayer";

// Icons
import SalesOperationsIcon from "@/assets/icons/header/dataPages/sales-operations-icon.svg";

export default function SalesOperations() {
	return (
		<PageLayer title={"Sales Operations"} icon={SalesOperationsIcon}>
			<SalesOperationsLayer />
		</PageLayer>
	);
}
